(function () {
  document.querySelectorAll('.video-panel__play-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const panel = btn.closest('.video-panel');
      const media = panel.querySelector('.video-panel__media');
      const poster = media.querySelector('.video-panel__poster');
      const embedUrl = btn.dataset.embedUrl;

      if (poster) {
        poster.remove();
      }

      if (embedUrl) {
        const separator = embedUrl.indexOf('?') !== -1 ? '&' : '?';
        const iframe = document.createElement('iframe');
        iframe.src = embedUrl + separator + 'autoplay=1';
        iframe.allowFullscreen = true;
        iframe.setAttribute('loading', 'eager');
        iframe.style.cssText =
          'position:absolute;inset:0;width:100%;height:100%;border:0';
        media.appendChild(iframe);
      } else {
        const video = media.querySelector('video');

        if (video) {
          video.play();
        }
      }

      btn.remove();
    });
  });
})();
